<c3-config-section-box
  [title]="TP_SECTIONS_INFO['personal-experiments'].label"
  [icon]="TP_SECTIONS_INFO['personal-experiments'].icon"
>
  <p config-description>{{ TP_SECTIONS_INFO["personal-experiments"].description }}</p>

  <div [c3ConfigForm]="this">
    <mat-table [dataSource]="dataSource" matSort>
      <!-- Column selection -->
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef class="flex-5">
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            *ngIf="dataSource.data.length > 0"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="flex-5">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="onSelectionChange(row)"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <!-- Column personal-experiment name -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Esperimento</mat-header-cell>

        <mat-cell *matCellDef="let pe" class="layout-row layout-align-start-center">
          <span>{{ pe.label }}</span>
        </mat-cell>
      </ng-container>

      <!-- Column startDate -->
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Data d'inizio</mat-header-cell>

        <mat-cell *matCellDef="let pe" class="layout-row layout-align-start-center">
          <mat-form-field compact>
            <input
              matInput
              [matDatepicker]="startDatePicker"
              [(ngModel)]="pe.startDate"
              (ngModelChange)="onStartDateChange()"
              [disabled]="!selection.isSelected(pe)"
              readonly
              [min]="today"
            />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- TABLE HEADER -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <div class="empty-list-msg" *ngIf="dataSource.data.length === 0" class="empty-list-msg">
      <i>Non sono presenti esperimenti personali prescrivibili al paziente</i>
    </div>
  </div>
</c3-config-section-box>
